module.exports = __webpack_public_path__ + "components/flag/static/square/ug-6e243dcd37a701e30e936a047d755a25.svg";